import { render, staticRenderFns } from "./ProductTypeForecastGroupForm.vue?vue&type=template&id=50764800&scoped=true&"
import script from "./ProductTypeForecastGroupForm.vue?vue&type=script&lang=ts&"
export * from "./ProductTypeForecastGroupForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProductTypeForecastGroupForm.vue?vue&type=style&index=0&id=50764800&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50764800",
  null
  
)

export default component.exports